// import * as React from 'react'
// import classNames from 'classnames'

import { cardImgSizes } from 'ui-component-library/utils/imgSizes'

import type { Image, LinkType } from 'types'

import Link from 'content-components/_Primatives/Link'
import ArticleLink from 'ui-component-library/components/00-Primitives/ArticleLink'
import { InlineImage } from 'content-components/_Primatives/Images'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'

import style from './style.scss'

type Props = {
  button?: LinkType
  captionText?: string
  image: Image
  isModal?: boolean
  headlineText: string
  link?: LinkType
  onLoaded?: () => void
}

// // DailyContentImage.defaultProps = {
// //   button: undefined,
// //   captionText: '',
// //   className: '',
// //   link: undefined,
// //   onLoaded: () => {},
// // }

// function DailyContentImage(props: Props) {
//   const {
//     button,
//     captionText,
//     className,
//     image,
//     link,
//     isModal,
//     onLoaded,
//   } = props

//   return (
//     <div className={classNames(style.wrapper, className)}>
//       {link ? (
//         <Link target={link.target} url={link.url}>
//           <Photo
//             gradient={false}
//             image={image}
//             sizes={cardImgSizes}
//             onLoaded={onLoaded}
//           />
//         </Link>
//       ) : (
//         <Photo
//           gradient={false}
//           image={image}
//           isModal={isModal}
//           sizes={cardImgSizes}
//           onLoaded={onLoaded}
//         />
//       )}
//       {captionText && (
//         <TextBlock
//           className={classNames(style.contentSpacing, style.captionText)}
//           small
//         >
//           {captionText}
//         </TextBlock>
//       )}
//       {button && (
//         <ArticleLink
//           articleSource='internal'
//           isVideo={button.isVideo}
//           url={button.url}
//         >
//           {button.text}
//         </ArticleLink>
//       )}
//     </div>
//   )
// }

function FeaturedImageContent({
  image,
  isModal,
  button,
  link,
  captionText,
  headlineText,
  onLoaded,
}: Props) {
  return (
    <>
      {link ? (
        <Link
          aria-label={`Go to ${headlineText}`}
          target={link.target}
          url={link.url}
        >
          <InlineImage
            gradient={false}
            image={image}
            isModal={isModal}
            sizes={cardImgSizes}
            onLoaded={onLoaded}
          />
        </Link>
      ) : (
        <InlineImage
          gradient={false}
          image={image}
          isModal={isModal}
          sizes={cardImgSizes}
          onLoaded={onLoaded}
        />
      )}
      {captionText && (
        <TextBlock className={style.captionText}>{captionText}</TextBlock>
      )}
      {button && (
        <ArticleLink
          articleSource='internal'
          isVideo={button.isVideo}
          url={button.url}
        >
          {button.text}
        </ArticleLink>
      )}
    </>
  )
}

export default FeaturedImageContent
